import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, Observable, shareReplay,BehaviorSubject } from 'rxjs';
import { ConfidenceLevel } from 'src/app/shared/constants/file.constants';
import { COUNTRY_ID } from 'src/app/shared/constants/local-storage-items.constants';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../../data/local-storage.service';
import { BaseService } from '../base/base.service';
import { CacheService } from '../cache.service';
import { AiAssets } from 'src/app/shared/models/ai-models/ai-assets.model';

@Injectable({
  providedIn: 'root',
})
export class PredictiveDataService extends BaseService {
  private readonly _urlPrefix = `${environment.maintenance.urlPrefix}/predictive-data`;
  private aiJobsExisting = new BehaviorSubject<any>(null); 
  aiJobsExisting$ = this.aiJobsExisting.asObservable();
  constructor(
    http: HttpClient,
    private cache: CacheService,
    private localStorageService: LocalStorageService
  ) {
    super(http);
  }

  public getAvarageJobCost(data: {
    primaryJobType: string;
    secondaryJobType: string;
    suburbId: string;
    isReqFromAiJob:boolean;
  }) {
    const key = this.queryParams(data);
    return this.cache
      .get(
        `${this.constructor.name}_${this.getAvarageJobCost.name}`,
        key,
        this.get<{
          averageCost: number;
          confidenceLevel: ConfidenceLevel;
        }>(`${this._urlPrefix}/avarage-job-cost${key}`),
        []
      )
      .pipe(filter((d) => !!d));
  }

  private jobTypes: Observable<any>;
  private jobTypeKey = '';
  getJobTypes(title: string, description: string, isReqFromAiJob:boolean = true) {
    var countryId = this.localStorageService.get(COUNTRY_ID);
    if (this.jobTypeKey === `${title}${description}${countryId}`) {
      return this.jobTypes;
    }

    this.jobTypeKey = `${title}${description}${countryId}`;
    let requestBody = {
      Title: title,
      Description: description,
      CountryId: countryId,
      IsReqFromAiJob :isReqFromAiJob
    };
    this.jobTypes = this.post<any>(
      `${this._urlPrefix}/job-types`,
      requestBody
    );
    return this.jobTypes;
  }

  getJobBudget(title: string, description: string, isReqFromAiJob:boolean = true) {
    let requestBody = {
      Title: title,
      Description: description,
      IsReqFromAiJob: isReqFromAiJob,
    };
    return this.post<any>(`${this._urlPrefix}/job-budget`, requestBody);
  }

  getJobAvarageTime(data: {
    primaryJobType: string;
    secondaryJobType: string;
    suburbId: string;
    isReqFromAiJob : boolean ;
  }) {
    const key = this.queryParams(data);
    return this.get<any>(`${this._urlPrefix}/job-avarage-time${key}`);
  }

  getJobDescriptionTitle(description: string, attachments : any[]) {
    let requestBody = {
      Description: description,
      Attachments : attachments
    };
    return this.post<any>(`${this._urlPrefix}/job-description-title`, requestBody);
  }
  getAssetsdata(
    propertyId: string,
    description: string,
    imageUrls:  any[]|null,
  ) {
    let assetrequestBody = {
      PropertyId:propertyId,
      Description: description,
      ImageUrls : imageUrls
    };
    console.log(assetrequestBody);
    
    return this.post<any>(`${this._urlPrefix}/get-assets`,assetrequestBody);
  }

  getJobUrgency(data: {
    description: string;
    isReqFromAiJob:boolean;
  }) {
    const key = this.queryParams(data);
    return this.get<any>(`${this._urlPrefix}/job-urgency${key}`);
  }

  getExistingJobs(isExisting:boolean) {
    this.aiJobsExisting.next(isExisting);
  }
}
